const StyleType = {
  Primary: "PRIMARY",
  Secondary: "SECONDARY",
  Tertiary: "TERTIARY",
  Danger: "DANGER",
  Success: "SUCCESS",
  Warning: "WARNING",
  Info: "INFO",
  Link: "LINK",
  Filter: "FILTER",
  Ghost: "GHOST",
  Plain: "PLAIN",
  Special: "SPECIAL",
};

export default Object.freeze(StyleType);
